// §9.17/D139 — Grid-Badge `⊞ N×M` in der Studio-Leiste: zeigt das (erkannte/gesetzte) Gitter
// und öffnet dieselbe manuelle Grid-UI vorbelegt (Fehl-Erkennung heilbar, Happy Path dialogfrei).

export function GridBadge({
  cols,
  rows,
  method,
  onClick,
}: {
  cols: number;
  rows: number;
  method: "alpha" | "chroma" | "none";
  onClick: () => void;
}) {
  // method='none' ⇒ kein Gitter erkannt (Einzelbild) — das Badge bleibt der Heil-/Eingabe-Weg
  // zum manuellen Grid (Codex-P1-2: sonst wäre der GridDialog bei Fehlschlag unerreichbar).
  const detected = method !== "none";
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1 rounded-lg border border-border bg-surface-2 px-2 py-1 text-xs text-muted hover:text-text"
      title={detected ? `Spritesheet-Gitter ${cols}×${rows} (${method}) — anpassen` : "Spritesheet-Gitter manuell angeben"}
    >
      <span aria-hidden>⊞</span>
      <span className="tabular-nums">{detected ? `${cols}×${rows}` : "Gitter"}</span>
    </button>
  );
}
